import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { ActionItemsGridRowRendererComponent } from 'src/app/components/_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SkillMatrixService } from 'src/app/_services/skill-matrix/skill-matrix.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-skill-matrix',
  templateUrl: './skill-matrix.component.html',
  styleUrls: ['./skill-matrix.component.scss']
})
export class SkillMatrixComponent implements OnInit {
  form: FormGroup;
  skillForm;
  rowData: any;
  public columnDefs: ColDef[]; 
  modeAction:number = 1 //1 - create // 2 - update
  // gridApi and columnApi  
  private api: GridApi;  
  private columnApi: ColumnApi;  
   defaultColDef:any;
   rowSelection:any
  tenantId: string;
  currentUser: any;
  selectedFile: File;
  sampleGridFrameworkComponents: any;
  gridLength = 0;
  skillMatrix: any[] = [];
  skillsDictionary: any;
  public apiData: any = {};
  public skillMatrixData: any = {};
  public skillsMappedData = {};

  constructor(
    private SkillMatrixService: SkillMatrixService,
    private formBuilder: FormBuilder,
    private storageService: LocalStorageService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
  ) { 
    this.defaultColDef = {
      flex: 1,
      minWidth: 100,
      resizable: true,
    };

    this.sampleGridFrameworkComponents = {
      actionRowRendererComponent: ActionItemsGridRowRendererComponent
    };

    this.form = this.formBuilder.group({
      file: ['', Validators.required],
    });

    this.skillForm = this.formBuilder.group({
      id: new FormControl(''),
      skill: new FormControl(''),
      subSkill: new FormControl(''),
    });
  }

  ngOnInit(): void {
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.tenantId = this.storageService.get('tenantId');
    // this.getUserList();
    this.getSkillMetrix();
  }

  getSkillMetrix(){
    this.columnDefs = [];
    let columnGroups: any[] = [];
    this.SkillMatrixService.getUserSkillMetrix().subscribe((response: any) => {
      if(response.length > 0){
        this.skillMatrixData = response;
        this.SkillMatrixService.getSkillMap().subscribe((skillResponse: any) => {
          this.apiData = skillResponse;
          this.columnDefs = [];
          this.rowData = [];

          const column1 = {
              headerName: "Employee Id",
              field: "localId",
              minWidth: 100,
              editable: false // Make it editable if required
            };
          const column2 =  {
              headerName: "Employee Name",
              field: "username",
              minWidth: 200,
              editable: false // Make it editable if required
            };
          const column3 = {
              headerName: "Position",
              field: "position",
              minWidth: 100,
              editable: false // Make it editable if required
            };

          columnGroups.push(column1);
          columnGroups.push(column2);
          columnGroups.push(column3);
          for(const key in this.apiData){
            if(this.apiData.hasOwnProperty(key)){
              const items = this.apiData[key];

              const columnGroup = {
                headerName: key,
                children: []  // This will hold the columns under this group
              };

              items.forEach(item => {
                columnGroup.children.push({
                  headerName: item,
                  field: item.replace(/\s+/g, '_'),  // Use the item name as the field, sanitize for spaces
                  cellRenderer: (params: any) => params.value,  // Customize cell rendering if needed
                  editable: true
                });
              });

              columnGroups.push(columnGroup);
              this.columnDefs = columnGroups;
            }
          }

          for(let i=0; i<this.skillMatrixData.length; i++){
            // Prepare the rowData by mapping skill values to the correct columns
            const row = { username: this.skillMatrixData[i].userId + ' . ' + this.skillMatrixData[i].username, localId: this.skillMatrixData[i].localId, position: this.skillMatrixData[i].position };  // Add the person's name to the row
              this.skillMatrixData[i].skillValues.forEach((skillEntry: any) => {
                const subSkill = skillEntry.subSkill;  // E.g., "Cockpit System Architecture"
                const fieldName = `${subSkill.replace(/\s+/g, '_')}`;

                // Add the value for the current skill to the corresponding field in the row
                row[fieldName] = skillEntry.currentSkillValue;  // We can use `currentSkillValue` or `requiredSkillValue`
              });

            this.rowData.push(row);            // Push the row data to rowData
          }
        });
      }    
    });
  }

  getSkill(subSkill){
    for(const key in this.apiData){
      if(this.apiData.hasOwnProperty(key)){
        const items = this.apiData[key];
        for(let i = 0; i < items.length; i++) {
          if(items[i] === subSkill) {
            return key;
          }
        }
      }
    }
  }

  onCellValueChanged(params): void{
    const { oldValue, newValue, colDef, data, node } = params;
    let skill = this.getSkill(params.colDef.headerName);
    let userId = parseInt(params.data.username.split(' . ')[0]);

    let skillDetails = {
      userId: userId,
      skill: skill,
      subSkill: params.colDef.headerName,
      currentSkillValue: parseFloat(newValue)
    }
    this.SkillMatrixService.createUserSkillValuesByName(skillDetails).subscribe(response => {
      this.openSnackBar('Skill Value Updated!!!');
      this.getSkillMetrix();
    });
  }

  openSnackBar(message: string) {
    this.snackBar.open(message, 'Close', { duration: 3000 });
  }

  createOpenModal() {
    this.modeAction = 1;
    this.skillForm.reset();
    this.skillForm.patchValue({
      skill: '',
      subSkill: '',
    });
  }

  createSkill(){
    let skillDetails = {
      skill: this.skillForm.get('skill').value,
      subSkill: this.skillForm.get('subSkill').value,
    }
    this.SkillMatrixService.createSkills(skillDetails).subscribe((response : any) => {
      this.openSnackBar('Skill Added Updated!!!');
      $('#closeModal').trigger('click');
      this.getSkillMetrix();
    });
  }

  // one grid initialisation, grap the APIs and auto resize the columns to fit the available space
  onGridReady(params): void {
    this.api = params.api;
    this.columnApi = params.columnApi;
    this.api.sizeColumnsToFit();
  } 

  backToGoalProfile(){
    this.router.navigate([this.tenantId + '/dashboard/hr/goal-profile-hr/goal-profile']);
  }


}
